import React from "react";
import { motion } from "framer-motion";
import { GiftIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { IMAGES } from "../src/config";
const bonuses = [{
  n: 1,
  title: "Native-Voice Prompts",
  value: "$47",
  desc: "Los comandos exactos para que la IA escriba con el tono de un estratega senior de USA."
}, {
  n: 2,
  title: "El Script de los $10.000",
  value: "$37",
  desc: "La plantilla de propuesta para contratos High-Ticket. Copia, pega y factura."
}, {
  n: 3,
  title: 'Guía "Dólares en Mano"',
  value: "$27",
  desc: "El manual para latinos: cobra en USD y mueve tu capital de forma legal y segura."
}, {
  n: 4,
  title: "LinkedIn Mastery AI",
  value: "$17",
  desc: "Hackea el algoritmo de LinkedIn para que los clientes de USA te encuentren a TI."
}, {
  n: 5,
  title: "10 Nichos Ganadores 2026",
  value: "$17",
  desc: "Te decimos exactamente dónde está el dinero este año para no perder tiempo."
}];
export function Bonuses() {
  return <section className="w-full bg-gradient-to-b from-[#0a0a1f] to-[#12102a] py-16" data-id="element-37" data-mp="3ieg5kyb27wy7">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-38" data-mp="3ic3ik6qg2wea">
        <div className="mx-auto max-w-2xl text-center" data-id="element-39" data-mp="3dek3j4lxafla">
          <div className="inline-flex items-center gap-2 rounded-full bg-emerald-500/15 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-emerald-300" data-id="element-40" data-mp="3r6qgkhts46gi">
            <GiftIcon className="h-4 w-4" data-id="element-41" data-mp="3n5y7bokwq1k8" />
            No vienes solo por el ebook
          </div>
          <h2 className="mt-4 font-display text-2xl font-extrabold text-white sm:text-4xl" data-id="element-42" data-mp="2zfu6foz3sfwx">
            5 Bonos Explosivos{" "}
            <span className="text-emerald-400" data-id="element-43" data-mp="38g8ugw3gc944">(GRATIS)</span>
          </h2>
          <p className="mt-3 text-slate-300" data-id="element-44" data-mp="38e5vhmkbn5n9">
            Si desbloqueas tu acceso hoy, te llevas todo esto sin costo adicional.
          </p>
        </div>

        <div className="mt-10 grid items-center gap-8 lg:grid-cols-2" data-id="element-45" data-mp="np004uox2gap">
          <img src={IMAGES.bonuses} alt="Bonos incluidos con The Bilingual Sales Machine" className="w-full rounded-2xl border border-white/10 shadow-2xl shadow-violet-900/30" data-id="element-46" data-mp="ir6srybvng8u" />

          <div className="space-y-3" data-id="element-47" data-mp="3hgy9h8em9etk">
            {bonuses.map((b, i) => <motion.div key={b.n} initial={{
            opacity: 0,
            x: 14
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.06
          }} className="flex items-center gap-4 rounded-xl border border-white/10 bg-white/[0.03] p-4" data-id="element-48" data-mp="3lj3161li81dk" data-mpi={i}>
                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-emerald-500/15 font-display text-lg font-bold text-emerald-300" data-id="element-49" data-mp="32t3grs0lzagh">
                  {b.n}
                </div>
                <div className="flex-1" data-id="element-50" data-mp="2a4pgt6pym42a">
                  <div className="flex flex-wrap items-center gap-2" data-id="element-51" data-mp="2a3o6x5kojnm5">
                    <p className="font-semibold text-white" data-id="element-52" data-mp="2f30opbwp24hv">{b.title}</p>
                    <span className="rounded-full bg-emerald-500/15 px-2 py-0.5 text-xs font-semibold text-emerald-300" data-id="element-53" data-mp="27jzuxibp3p7p">
                      Valor {b.value}
                    </span>
                  </div>
                  <p className="mt-1 text-sm text-slate-400" data-id="element-54" data-mp="1xlk2nc0xm9wm">{b.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center" data-id="element-55" data-mp="1tjyw08ezqruv">
          <p className="text-center text-slate-300" data-id="element-56" data-mp="1olf5rvtd6twp">
            Valor real de todo el paquete:{" "}
            <span className="text-slate-500 line-through" data-id="element-57" data-mp="1ju5mdcyesmt9">$172+</span> — hoy lo
            desbloqueas por el precio de un café.
          </p>
          <CTAButton className="mt-6" data-id="element-58" data-mp="1et9g4sql4oko" />
        </div>
      </div>
    </section>;
}